import { Component, ChangeDetectionStrategy, inject, signal, ViewChild, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngxs/store';
import { LogoComponent } from '../logo/logo.component';
import { SearchBarComponent } from '../searchbar/search-bar.component';
import { CartComponent } from '../cart/cart.component';
import { AccountComponent } from '../account/account.component';
import { MobileHeaderComponent } from '../mobile/components/mobile-header/mobile-header.component';
import { MobileMenuComponent } from '../mobile/mobile-menu.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { Navigate } from '@ngxs/router-plugin';
import { CartState } from '@app/state/cart/cart.state';
import { faExclamationTriangle, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { faShoppingCart, faUserAlt } from '@fortawesome/pro-light-svg-icons';
import { AccountState } from '@app/state/account/account.state';
import { BoxDealsState } from '@app/state/box-deals/box-deals.state';
import { environment } from '@env/environment.development';
import { LoginRoute } from '@app/app.routes.config';
import { PlatformService } from '@app/modules/shared/services/platform-service';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule,
    LogoComponent,
    SearchBarComponent,
    CartComponent,
    AccountComponent,
    MobileHeaderComponent,
    MobileMenuComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
  readonly platformService = inject(PlatformService);

  showBpostBusyMessage = signal(environment.bpostBusyMessage);
  flashShoppingCartIconBool = signal(false);
  userEmail = signal('');

  exclamationTriangle = faExclamationTriangle;
  times = faTimes;

  @ViewChild('mobileMenu', { static: false }) mobileMenu: MobileMenuComponent;

  showCartMenu = model<boolean>();
  showMobileMenu = model<boolean>();

  private store = inject(Store);

  countNumberProductsInCart = toSignal(this.store.select(CartState.selectCountProductsInCart), { initialValue: 0 });
  isLoggedIn = toSignal(this.store.select(AccountState.isAuthenticated), { initialValue: false });
  temporaryDiscounts = toSignal(this.store.select(BoxDealsState.selectTemporaryDiscounts), { initialValue: [] });

  removeMessage() {
    this.showBpostBusyMessage.set(false);
  }

  registerOrLogin() {
    this.store.dispatch(new Navigate([LoginRoute]));
  }

  protected readonly faShoppingCart = faShoppingCart;
  protected readonly faUserAlt = faUserAlt;
}
